// @flow
import React from 'react'
import styled from 'styled-components'
import { Title, StyledP, StyledAnchor } from 'src/theme/globalStyle'

const ExpiredContainer = styled.div`
  width: 620px;
  background-color: white;
  border-radius: 3px;
`

const ExpiredImage = styled.header`
  width: 100%;
  height: 220px;
  background-image: url(${(props: { header: string }) => props.header});
  background-position: right;
  background-size: cover;
  border-radius: 3px 3px 0 0;
`

const ExpiredBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px auto;
  max-width: 420px;
`

const Heading = styled.h3`
  font-family: 'RelativeBook', 'Helvetica', 'Arial', sans-serif;
  font-size: 14px;
  color: ${props => props.theme.darkText};
`

export const Expired = ({ headerImage }: { headerImage: string }) => {
  return (
    <ExpiredContainer>
      <ExpiredImage header={headerImage} />
      <ExpiredBody>
        <Title>Your link has expired</Title>
        <Heading>The link expires 48h from when it was sent to you.</Heading>
        <StyledP isCentered>
          We cannot assure you that this room is still available. Please contact the sales team at
          The Collective if you still want to create the booking.
        </StyledP>
        <StyledAnchor href="mailto:sales@thecollective.co.uk">
          sales@thecollective.co.uk
        </StyledAnchor>
        <StyledP>+44 (0) 207 183 5478</StyledP>
      </ExpiredBody>
    </ExpiredContainer>
  )
}



// WEBPACK FOOTER //
// ./src/components/Expired/index.js